import { SymbolGallery } from 'elements/minute/sidebar/sidebarComponents/complex/SymbolGallery';
import { IIconV2WorldMarker } from 'react-give-me-map';
import { IImageV2WorldMarker } from 'react-give-me-map/dist/utils/world/worldTypes';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    marker: IIconV2WorldMarker | IImageV2WorldMarker;
    dragAndDropEnabled?: boolean;
    initialRowsVisible?: number;
    allowEmpty?: boolean;
    onSelected?: (params: { imageUrl: string; color?: string }) => void;
}

export const ImageGalleriesSymbolContent = (props: Props): JSX.Element => {
    return (
        <S_ImageGalleriesSymbolContent className={props.className}>
            <SymbolGallery
                // This sets selectedImageUrl to something not existent
                // in the symbol gallery if the imageUrl is set but iconUrl
                // is null (there is no icon)
                selectedImageUrl={
                    props.marker?.elementData.generatedIconUrl ??
                    props.marker?.elementData.generatedImageUrl
                }
                color={props.marker?.elementData.generatedIconColor}
                onSelected={props.onSelected}
                dragAndDropEnabled={props.dragAndDropEnabled}
                initialRowsVisible={props.initialRowsVisible}
                allowEmpty={props.allowEmpty}
            />
        </S_ImageGalleriesSymbolContent>
    );
};

const S_ImageGalleriesSymbolContent = styled.div``;
